import type InputType from "../../Input/InputType";
import { JsonInputType } from "../../Input/JsonInputType";
import type { SideName } from "../../Side/SideName";
import Plate from "../Plate";

export default abstract class Oval extends Plate {
	public calculateSideLength(_side: SideName, input: InputType) {
		const length = Number(input[JsonInputType.Length]);
		const width = Number(input[JsonInputType.Width]);

		if (!(Number.isNaN(length) || Number.isNaN(width))) {
			return this.calculateOutlineLength(length, width);
		}

		return undefined;
	}

	protected abstract calculateOutlineLength(length: number, width: number): number;
}
